import React from "react"
import { Control } from "react-hook-form"
import UpgradeAlert from "components/elements/UpgradeAlert"
import { Box } from "@chakra-ui/react"
import BasicInputs from "./BasicInputs/BasicInputs"
import FormDetailHeader from "./FormDetailHeader"

type Props = {
  control: Control<object, any>
  eventId: string
  showUpgradeAlert: boolean
  name: string
  sendConfirmationEmails: boolean
}

const Waitlist = ({
  control, eventId, showUpgradeAlert, name, sendConfirmationEmails,
}: Props) => (
  <Box pb={4}>
    <FormDetailHeader
      name={name}
      description="Requires prospective guests to apply for the event and join a waiting list. You can then qualify and either confirm or decline their registration."
    />
    {showUpgradeAlert && <UpgradeAlert mb={8} maxW="full" text="Requires Corporate Plan or higher" />}
    <BasicInputs
      control={control}
      eventId={eventId}
      showVisibilityInput
      showQuantityInput
      showLimitPerSubmission
      showGuestCreation
      sendConfirmationEmails={sendConfirmationEmails}
    />
  </Box>
)

export default Waitlist
